"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SortIcon(props) {
    return (react_1.default.createElement(react_native_svg_1.default, Object.assign({ width: 16, height: 11, viewBox: "0 0 16 11", fill: "none" }, props),
        react_1.default.createElement(react_native_svg_1.Path, Object.assign({ d: "M15.174 1.652H.826A.828.828 0 010 .826C0 .372.372 0 .826 0h14.348c.454 0 .826.372.826.826a.828.828 0 01-.826.826zM11.272 5.947H.867A.828.828 0 01.04 5.12c0-.454.372-.826.826-.826h10.405c.454 0 .826.372.826.826a.828.828 0 01-.826.826zM7.969 10.28H.867a.828.828 0 01-.826-.825c0-.454.372-.826.826-.826h7.102c.454 0 .826.372.826.826a.828.828 0 01-.826.825z", fill: "#F15A22" }, props))));
}
exports.default = SortIcon;
